/**
 * @module views\mdl\person
 */
import Component from "vue-class-component";
import { Mixins } from "vue-property-decorator";
import DependedStructure from "../dependedStructure/dependedStructure";

@Component
export default class Person extends Mixins(DependedStructure) {
  protected module = "mes.business.mdl.person.service";
  protected cls = "PersonService";
}
